import React from 'react';
import {Typography} from '@material-ui/core';
import {Close as DeleteIcon, InsertDriveFile as FileIcon} from '@material-ui/icons';
import {formatBytes} from '@pluto/utils';

interface Props {
    src: string;
    handleDelete: () => void;
    data?: File;
}

function FileImportPreview({handleDelete, data}: Props) {
    const {name, size = 0} = data || {};

    return (
        <div className="import__dropzon-preview">
            <div className="import__dropzon-preview-file">
                <FileIcon />
                <div className="import__dropzon-preview-file-wrapper">
                    <Typography variant="h5">{name}</Typography>
                    <Typography variant="h6">{formatBytes(size)}</Typography>
                    <DeleteIcon onClick={handleDelete} />
                </div>
            </div>
        </div>
    );
}

export default FileImportPreview;
